import { ClassValue } from 'clsx';
import { ReactNode } from 'react';
import { View } from '@shared/components/View';
import { Field } from '@shared/data/entity/fields/Field';
import styles from './CollectionViewFields.module.css';

/**
 * The value rendered as `data-field-type`, which per-view CSS modules select on.
 * Derived from the field union so it can't drift; `InputButton` is the one
 * static component that renders through this container without a field.
 */
export type CollectionViewFieldType = Field['fieldType'] | 'InputButton';

interface Props {
  children: ReactNode;
  fieldType: CollectionViewFieldType;
  className?: ClassValue;
  /** Text fields only: renders `data-multiline` so per-view CSS can wrap differently. */
  multiline?: boolean;
  /** Input button only: renders `data-with-label` for label spacing. */
  withLabel?: boolean;
}

export function CardCollectionViewFieldContainer({
  children,
  fieldType,
  className,
  multiline,
  withLabel,
}: Props) {
  return (
    <View
      className={[styles.field, className]}
      data-field-type={fieldType}
      data-multiline={multiline || undefined}
      data-with-label={withLabel || undefined}
    >
      {children}
    </View>
  );
}
